import { get } from 'lodash'
import { isNonEmptyNumber } from '@labrav/common'
import {
  AzurePriceInputOption,
  AzureRecurrentPriceField,
  OfferRecurrentPricingType,
  RecurrentPriceModeType,
} from '../types/flyout'
import type {
  AzurePlanDimension,
  ProductPlan,
} from '../modules/productsListing/types'

export const convertProductPlanToOfferPlan = (productPlan?: ProductPlan) => {
  if (!productPlan) return productPlan

  const { pricingData, originalPricingData } =
    convertProductPlanPricingToOffer(productPlan)

  const offerPlan = {
    planId: productPlan?.planId,
    labraPlanId: productPlan.planId,
    azurePlanId: productPlan?.azurePlanId,
    description: productPlan?.description,
    displayName: productPlan?.displayName,
    offerPricingType: OfferRecurrentPricingType.SAASNEWCUSTOMIZEDPLANS,
    pricing: pricingData,
    originalPricing: originalPricingData,
    discountPercentage: null,
  }
  return { ...offerPlan }
}

export const convertProductPlanPricingToOffer = (productPlan: ProductPlan) => {
  const pricesValue = [
    get(productPlan, 'pricing', [])[0],
  ] as AzureRecurrentPriceField[]

  const recurrentPriceModeValue =
    isNonEmptyNumber(productPlan?.minQuantity) &&
    isNonEmptyNumber(productPlan?.maxQuantity)
      ? RecurrentPriceModeType.PERUSER
      : RecurrentPriceModeType.FLATRATE
  const meters = { ...getCustomMeteres({ productPlan, pricesValue }) }

  return {
    pricingData: {
      recurrentPrice: {
        recurrentPriceMode: recurrentPriceModeValue,
        priceInputOption: AzurePriceInputOption.USD,
        userLimits: {
          min: productPlan?.minQuantity,
          max: productPlan?.maxQuantity,
          minEnable: true,
          maxEnable: true,
        },
        prices: pricesValue,
      },
      customMeters: {
        meters: { ...meters },
      },
    },
    originalPricingData: {
      recurrentPrice: {
        recurrentPriceMode: recurrentPriceModeValue,
        priceInputOption: AzurePriceInputOption.USD,
        userLimits: {
          min: productPlan?.minQuantity,
          max: productPlan?.maxQuantity,
          minEnable: true,
          maxEnable: true,
        },
        prices: productPlan?.pricing,
      },
      customMeters: {
        meters: { ...getCustomMeteres({ productPlan }) },
      },
    },
  }
}

export const getCustomMeteres = ({
  productPlan,
  pricesValue,
}: {
  productPlan: ProductPlan
  pricesValue?: AzureRecurrentPriceField[]
}) => {
  let customMetersObject = {}

  const productsMeters = (productPlan?.dimensions as AzurePlanDimension)?.meters
  productsMeters?.forEach(
    ({ cloudDimensionId, includedQuantities, ...remaingProductsMeterData }) => {
      customMetersObject = {
        ...customMetersObject,
        [cloudDimensionId]: {
          ...remaingProductsMeterData,
          includedQuantities: pricesValue?.length
            ? includedQuantities?.filter(
                item =>
                  item?.billingTerm?.type ===
                    pricesValue[0]?.billingTerm?.type &&
                  item?.billingTerm?.value ===
                    pricesValue[0]?.billingTerm?.value
              )
            : includedQuantities,
        },
      }
    }
  )
  return customMetersObject
}
